'use client'

import { useSession } from 'next-auth/react'

import { extractTokenFromClientSession } from '../../../session'
import { useQueryCustomerDeliveryAddresses } from '../queries/useQueryCustomerDeliveryAddresses'
import { useQueryCustomerInvoiceAddresses } from '../queries/useQueryCustomerInvoiceAddresses'

export const useCustomerAddresses = () => {
  const session = useSession()
  const token = extractTokenFromClientSession(session)

  const {
    data: deliveryAddresses,
    isLoading: isLoadingDelivery,
    isPending: isPendingDelivery
  } = useQueryCustomerDeliveryAddresses(token || '')

  const {
    data: invoiceAddresses,
    isLoading: isLoadingInvoice,
    isPending: isPendingInvoice
  } = useQueryCustomerInvoiceAddresses(token || '')

  return {
    deliveryAddresses,
    invoiceAddresses,
    isLoadingDelivery,
    isLoadingInvoice,
    isPendingDelivery,
    isPendingInvoice
  }
}
